module.exports = __webpack_public_path__ + "img/32.3d6905e5.svg";